// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItensStatus_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/menu_itens_status/salvar
 *
 * Returns the id of the created/updated menu item status plus a
 * confirmation message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MenuItensStatus_SalvarResponseDados {
menu_item_status_id: number
message: string
}

export type MenuItensStatus_SalvarResponse = ApiResponse<MenuItensStatus_SalvarResponseDados>;

registerResponseContract('MenuItensStatus_SalvarResponse', {
  menu_item_status_id: { type: 'number',  required: true },
  message:             { type: 'string',  required: true },
})
